
import { ArrowUpCircle, Users, Truck, Recycle, TrendingUp, Box, Package } from "lucide-react";

const NumbersSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-fabre-lightgray to-white relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 bg-fabre-green rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-fabre-teal rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-heading font-bold mb-4 text-fabre-gray">
            Nos chiffres clés
          </h2>
          <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-8 rounded-full"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Découvrez l'impact de notre engagement pour l'environnement à travers nos résultats concrets
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6 lg:gap-8">
          <div className="bg-white p-6 lg:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center border border-gray-100 min-h-[240px] flex flex-col justify-between">
            <div className="w-16 h-16 lg:w-18 lg:h-18 bg-gradient-to-br from-fabre-lightgreen to-fabre-green/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6 shadow-md">
              <ArrowUpCircle size={28} className="text-fabre-green lg:w-9 lg:h-9" />
            </div>
            <div className="flex-grow flex flex-col justify-center">
              <div className="text-3xl lg:text-4xl xl:text-5xl font-heading font-bold text-fabre-darkteal mb-2 lg:mb-3 leading-none break-words">
                85<span className="text-fabre-green text-2xl lg:text-3xl xl:text-4xl">%</span>
              </div>
              <p className="text-gray-600 font-medium text-sm lg:text-base leading-tight">Taux moyen de valorisation des déchets</p>
            </div>
          </div>
          
          <div className="bg-white p-6 lg:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center border border-gray-100 min-h-[240px] flex flex-col justify-between">
            <div className="w-16 h-16 lg:w-18 lg:h-18 bg-gradient-to-br from-fabre-lightgreen to-fabre-green/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6 shadow-md">
              <Users size={28} className="text-fabre-green lg:w-9 lg:h-9" />
            </div>
            <div className="flex-grow flex flex-col justify-center">
              <div className="text-3xl lg:text-4xl xl:text-5xl font-heading font-bold text-fabre-darkteal mb-2 lg:mb-3 leading-none break-words">80</div>
              <p className="text-gray-600 font-medium text-sm lg:text-base leading-tight">Collaborateurs engagés</p>
            </div>
          </div>
          
          <div className="bg-white p-6 lg:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center border border-gray-100 min-h-[240px] flex flex-col justify-between">
            <div className="w-16 h-16 lg:w-18 lg:h-18 bg-gradient-to-br from-fabre-lightgreen to-fabre-green/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6 shadow-md">
              <Truck size={28} className="text-fabre-green lg:w-9 lg:h-9" />
            </div>
            <div className="flex-grow flex flex-col justify-center">
              <div className="text-3xl lg:text-4xl xl:text-5xl font-heading font-bold text-fabre-darkteal mb-2 lg:mb-3 leading-none break-words">35</div>
              <p className="text-gray-600 font-medium text-sm lg:text-base leading-tight">Véhicules modernes et adaptés</p>
            </div>
          </div>
          
          <div className="bg-white p-6 lg:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center border border-gray-100 min-h-[240px] flex flex-col justify-between">
            <div className="w-16 h-16 lg:w-18 lg:h-18 bg-gradient-to-br from-fabre-lightgreen to-fabre-green/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6 shadow-md">
              <Recycle size={28} className="text-fabre-green lg:w-9 lg:h-9" />
            </div>
            <div className="flex-grow flex flex-col justify-center">
              <div className="text-3xl lg:text-4xl xl:text-5xl font-heading font-bold text-fabre-darkteal mb-2 lg:mb-3 leading-none break-words">9</div>
              <p className="text-gray-600 font-medium text-sm lg:text-base leading-tight">Sites de collecte et valorisation</p>
            </div>
          </div>
          
          <div className="bg-white p-6 lg:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center border border-gray-100 min-h-[240px] flex flex-col justify-between">
            <div className="w-16 h-16 lg:w-18 lg:h-18 bg-gradient-to-br from-fabre-lightgreen to-fabre-green/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6 shadow-md">
              <TrendingUp size={28} className="text-fabre-green lg:w-9 lg:h-9" />
            </div>
            <div className="flex-grow flex flex-col justify-center">
              <div className="text-3xl lg:text-4xl xl:text-5xl font-heading font-bold text-fabre-darkteal mb-2 lg:mb-3 leading-none break-words">
                +20<span className="text-fabre-green text-2xl lg:text-3xl xl:text-4xl">M€</span>
              </div>
              <p className="text-gray-600 font-medium text-sm lg:text-base leading-tight">de chiffre d'affaires</p>
            </div>
          </div>
          
          <div className="bg-white p-6 lg:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center border border-gray-100 min-h-[240px] flex flex-col justify-between">
            <div className="w-16 h-16 lg:w-18 lg:h-18 bg-gradient-to-br from-fabre-lightgreen to-fabre-green/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6 shadow-md">
              <Box size={28} className="text-fabre-green lg:w-9 lg:h-9" />
            </div>
            <div className="flex-grow flex flex-col justify-center">
              <div className="text-3xl lg:text-4xl xl:text-5xl font-heading font-bold text-fabre-darkteal mb-2 lg:mb-3 leading-none break-words">+1000</div>
              <p className="text-gray-600 font-medium text-sm lg:text-base leading-tight">bennes à disposition</p>
            </div>
          </div>
          
          <div className="bg-white p-6 lg:p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 text-center border border-gray-100 min-h-[240px] flex flex-col justify-between">
            <div className="w-16 h-16 lg:w-18 lg:h-18 bg-gradient-to-br from-fabre-lightgreen to-fabre-green/20 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6 shadow-md">
              <Package size={28} className="text-fabre-green lg:w-9 lg:h-9" />
            </div>
            <div className="flex-grow flex flex-col justify-center">
              <div className="text-3xl lg:text-4xl xl:text-5xl font-heading font-bold text-fabre-darkteal mb-2 lg:mb-3 leading-none break-words">
                +40000<span className="text-fabre-green text-2xl lg:text-3xl xl:text-4xl">t</span>
              </div>
              <p className="text-gray-600 font-medium text-sm lg:text-base leading-tight">de déchets ferreux recyclés</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NumbersSection;
